import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface ArrowBackProps {
  onClick?: () => void;
}

const ArrowBack: React.FC<ArrowBackProps> = ({ onClick }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <span
      className="arrow-back"
      role="button"
      tabIndex={0}
      aria-label={t('back_button')}
      onClick={onClick ?? (() => navigate(-1))}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') (onClick ?? (() => navigate(-1)))();
      }}
    >
      <svg width="26" height="26" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" style={{ display: 'block' }}>
        <path d="M12.5 15L7.5 10L12.5 5" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </span>
  );
};

export default ArrowBack;
